import React, { useState } from 'react';

interface MediCareLogoProps {
  width?: number;
  height?: number;
  className?: string;
  variant?: 'icon' | 'full';
}

const MediCareLogo: React.FC<MediCareLogoProps> = ({
  width = 32,
  height = 32,
  className,
  variant = 'icon',
}) => {
  const [hasImageError, setHasImageError] = useState(false);

  if (variant === 'full' && !hasImageError) {
    return (
      <img
        src="/assets/imgs/medicare.logo.png"
        alt="MediCare"
        className={className}
        style={{
          width: '100%',
          height: 'auto',
          display: 'block',
          flexShrink: 0,
        }}
        onError={() => setHasImageError(true)}
      />
    );
  }

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect width="32" height="32" rx="4" fill="#3f51b5" />
      <path
        d="M16 6L18 6L18 14L26 14L26 16L18 16L18 24L16 24L16 16L8 16L8 14L16 14L16 6Z"
        fill="white"
      />
    </svg>
  );
};

export default MediCareLogo;
